module.exports = __webpack_public_path__ + "static/media/next.23665ffa.svg";